import mixpanel from "mixpanel-browser";
import { AnalyticsEventBus, event } from "../analytics";

export class InAppMixpanelHandlers {
  static handleAll() {
    this.handleViewEvents();
  }

  static handleViewEvents() {
    AnalyticsEventBus.$on(event.in_app.tour_menu, (data) => {
      mixpanel.track(event.in_app.tour_menu);
    });
    AnalyticsEventBus.$on(event.in_app.tour_document, (data) => {
      mixpanel.track(event.in_app.tour_document);
    });
    AnalyticsEventBus.$on(event.in_app.view_later, (data) => {
      mixpanel.track(event.in_app.view_later);
    });
    AnalyticsEventBus.$on(event.in_app.user_right_tour_menu, (data) => {
      mixpanel.track(event.in_app.user_right_tour_menu);
    });
    AnalyticsEventBus.$on(event.in_app.user_right_view_later, (data) => {
      mixpanel.track(event.in_app.user_right_view_later);
    });
    AnalyticsEventBus.$on(event.in_app.exit_tour_menu_dashboard, (data) => {
      mixpanel.track(event.in_app.exit_tour_menu_dashboard);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_menu_revenue_expense, (data) => {
      mixpanel.track(event.in_app.exit_tour_menu_revenue_expense);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_menu_data_storage, (data) => {
      mixpanel.track(event.in_app.exit_tour_menu_data_storage);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_menu_account, (data) => {
      mixpanel.track(event.in_app.exit_tour_menu_account);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_menu_all_settings, (data) => {
      mixpanel.track(event.in_app.exit_tour_menu_all_settings);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_menu_app_center, (data) => {
      mixpanel.track(event.in_app.exit_tour_menu_app_center);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_menu_app_center_line_connect_pr, (data) => {
      mixpanel.track(event.in_app.exit_tour_menu_app_center_line_connect_pr);
    });
    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_dashboard, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_dashboard);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_revenue_expense, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_revenue_expense);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_data_storage, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_data_storage);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_account, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_account);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_all_settings, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_all_settings);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_app_center, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_app_center);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_app_center_line_connect_pr, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_app_center_line_connect_pr);
    });
    AnalyticsEventBus.$on(event.in_app.complete_tour_menu, (data) => {
      mixpanel.track(event.in_app.complete_tour_menu);
    });
    AnalyticsEventBus.$on(event.in_app.continue_tour_document_from_tour_menu, (data) => {
      mixpanel.track(event.in_app.continue_tour_document_from_tour_menu);
    });
    AnalyticsEventBus.$on(event.in_app.exit_tour_document_receipt, (data) => {
      mixpanel.track(event.in_app.exit_tour_document_receipt);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_document_receipt_create_customer, (data) => {
      mixpanel.track(event.in_app.exit_tour_document_receipt_create_customer);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_document_receipt_create_product, (data) => {
      mixpanel.track(event.in_app.exit_tour_document_receipt_create_product);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_document_receipt_create_payment, (data) => {
      mixpanel.track(event.in_app.exit_tour_document_receipt_create_payment);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_document_receipt_create_save_draft, (data) => {
      mixpanel.track(event.in_app.exit_tour_document_receipt_create_save_draft);
    });

    AnalyticsEventBus.$on(event.in_app.exit_tour_document_print_receipt, (data) => {
      mixpanel.track(event.in_app.exit_tour_document_print_receipt);
    });
    AnalyticsEventBus.$on(event.in_app.continue_tour_document_receipt, (data) => {
      mixpanel.track(event.in_app.continue_tour_document_receipt);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_document_receipt_create_customer, (data) => {
      mixpanel.track(event.in_app.continue_tour_document_receipt_create_customer);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_document_receipt_create_product, (data) => {
      mixpanel.track(event.in_app.continue_tour_document_receipt_create_product);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_document_receipt_create_payment, (data) => {
      mixpanel.track(event.in_app.continue_tour_document_receipt_create_payment);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_document_receipt_create_save_draft, (data) => {
      mixpanel.track(event.in_app.continue_tour_document_receipt_create_save_draft);
    });

    AnalyticsEventBus.$on(event.in_app.continue_tour_document_print_receipt, (data) => {
      mixpanel.track(event.in_app.continue_tour_document_print_receipt);
    });

    AnalyticsEventBus.$on(event.in_app.complete_tour_document, (data) => {
      mixpanel.track(event.in_app.complete_tour_document);
    });
    AnalyticsEventBus.$on(event.in_app.continue_tour_menu_from_tour_document, (data) => {
      mixpanel.track(event.in_app.continue_tour_menu_from_tour_document);
    });
    AnalyticsEventBus.$on(event.in_app.exit_in_app_peak_exp_settings, (data) => {
      mixpanel.track(event.in_app.exit_in_app_peak_exp_settings);
    });
    AnalyticsEventBus.$on(event.in_app.view_in_app_from_user_manual, (data) => {
      mixpanel.track(event.in_app.view_in_app_from_user_manual);
    });
    AnalyticsEventBus.$on(event.in_app.close_in_app_peak_exp_settings, (data) => {
      mixpanel.track(event.in_app.close_in_app_peak_exp_settings);
    });
    AnalyticsEventBus.$on(event.in_app.try_settings_in_app_peak_exp_settings, (data) => {
      mixpanel.track(event.in_app.try_settings_in_app_peak_exp_settings);
    });
  }
}
